"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackWithNewRelic = exports.trackWithHeap = exports.trackWithDebugConsole = exports.trackWithChromeExtension = exports.trackWithAdobeDataLayer = exports.trackWithAdobe = exports.trackErrorWithNewRelic = exports.trackErrorWithDebugConsole = exports.trackErrorWithChromeExtension = exports.default = exports.allTrackers = exports.allErrorTrackers = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var hasAnalyticsDataLayer = function hasAnalyticsDataLayer() {
  return !!(window && window._satellite && window.analyticsDataLayer);
};

var hasAdobeDataLayer = function hasAdobeDataLayer() {
  return !!(window && window._satellite && window.adobeDataLayer);
};

var analyticsExtensionId = 'gpdafgnjbakokfgimghlmgdpbfhheclh';

var trackWithAdobe = function trackWithAdobe(type, payload) {
  try {
    if (hasAnalyticsDataLayer()) {
      window.analyticsDataLayer.push({
        event: 'UNIVERSAL_EVENT',
        action: type,
        payload: payload
      });
    }
  } catch (err) {}
};

exports.trackWithAdobe = trackWithAdobe;

var trackWithAdobeDataLayer = function trackWithAdobeDataLayer(type, payload) {
  try {
    if (hasAdobeDataLayer()) {
      window.adobeDataLayer.push({
        event: type,
        payload: payload
      });
    }
  } catch (err) {}
};

exports.trackWithAdobeDataLayer = trackWithAdobeDataLayer;

var trackWithChromeExtension = function trackWithChromeExtension(type, payload) {
  try {
    // eslint-disable-next-line no-undef
    chrome.runtime.sendMessage(analyticsExtensionId, {
      type: type,
      payload: payload
    });
  } catch (err) {}
};

exports.trackWithChromeExtension = trackWithChromeExtension;

var trackWithNewRelic = function trackWithNewRelic(type, payload) {
  try {
    if (window && window.newrelic) {
      window.newrelic.addPageAction(type, payload);
    }
  } catch (err) {}
};

exports.trackWithNewRelic = trackWithNewRelic;

var trackWithHeap = function trackWithHeap(type, payload) {
  try {
    if (window.heap) {
      window.heap.track(type, payload);
    }
  } catch (err) {}
};

exports.trackWithHeap = trackWithHeap;

var trackErrorWithNewRelic = function trackErrorWithNewRelic(err) {
  try {
    if (window && window.newrelic) {
      window.newrelic.noticeError(err);
    }
  } catch (err) {}
};

exports.trackErrorWithNewRelic = trackErrorWithNewRelic;

var trackErrorWithChromeExtension = function trackErrorWithChromeExtension(err) {
  var error = {
    message: err.message
  };

  try {
    // eslint-disable-next-line no-undef
    chrome.runtime.sendMessage(analyticsExtensionId, {
      error: error
    });
  } catch (err) {}
};

exports.trackErrorWithChromeExtension = trackErrorWithChromeExtension;

var trackWithDebugConsole = function trackWithDebugConsole(type, payload) {
  console.log('ANALYTICS TRACKED!');
  console.log('Analytics Type: ', type);
  console.log('Payload: ', payload);
};

exports.trackWithDebugConsole = trackWithDebugConsole;

var trackErrorWithDebugConsole = function trackErrorWithDebugConsole(err) {
  console.error('ANALYTICS ERROR TRACKED!');
  console.error('Analytics Error: ', err);
};

exports.trackErrorWithDebugConsole = trackErrorWithDebugConsole;
var allTrackers = [trackWithAdobe, trackWithNewRelic, trackWithHeap, trackWithChromeExtension];
exports.allTrackers = allTrackers;
var allErrorTrackers = [trackErrorWithNewRelic, trackErrorWithChromeExtension];
exports.allErrorTrackers = allErrorTrackers;

var Tracker = /*#__PURE__*/function () {
  /**
   *
   * @param {[tracker]} trackers - Array of trackers to use when tracking analytics, defaults to all trackers
   * @param {[errorTracker]} errorTrackers  - Array of trackers to use when trackign errors, defaults to all error trackers
   */
  function Tracker() {
    var trackers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : allTrackers;
    var errorTrackers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : allErrorTrackers;

    _classCallCheck(this, Tracker);

    this._trackers = trackers || [];
    this._errorTrackers = errorTrackers || [];
  }

  _createClass(Tracker, [{
    key: "track",
    value: function track(type, payload) {
      this._trackers.forEach(function (tracker) {
        return tracker(type, payload);
      });
    }
  }, {
    key: "trackError",
    value: function trackError(err) {
      this._errorTrackers.forEach(function (errorTracker) {
        return errorTracker(err);
      });
    }
  }]);

  return Tracker;
}();

var tracker = function tracker(trackers, errorTrackers) {
  return new Tracker(trackers, errorTrackers);
};

var _default = tracker;
exports.default = _default;